export default {
  email: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]+$',
  name: "^[A-Za-z ,.'-]{1,50}$",
  password: '^(?=.*[a-zA-Z])(?=.*[0-9]).{8,254}$',
  phone: '^(?:\\+?61|0)[4|2|3|7|8](?:[ -]?[0-9]){8}$',
  tfn: '^[0-9]{8,9}$',
  otp: '^[0-9]{6}$'
};
